module.exports = __webpack_public_path__ + "assets/img/14_902.37ccdf25.jpg";